'use strict';

require('./assets/css/admin.css');
window.ZeroClipboard = require('zeroclipboard');
require('ng-clip');



// WEBPACK FOOTER //
// ./packages/custom/admin/public/index.js